import styled, { css } from "styled-components";

const SubmitButton = styled.button`
  display: inline-block;
  margin-bottom: 0;
  font-weight: normal;
  text-align: center;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  background-image: none;
  border: 1px solid transparent;
  white-space: nowrap;
  padding: 10px 14px;
  font-size: 1.4rem;
  line-height: 1;
  border-radius: 0px;
  user-select: none;
  color: white;
  background-color: #0288d1;
  border-radius: 1px;
  transition: background-color 0.2s;
  &:hover {
    background-color: #0277bd;
  }
  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.7;
      cursor: disabled;
    `}
`;

export default SubmitButton;
